// extracted by mini-css-extract-plugin
module.exports = {"icons":"SberPaymentBlockIcons_icons_1oiqn"};